import React from "react";

import { Page } from "app/layout/components";
import { useShare } from "app/shares/hooks";
import { ShareDetailPage } from "app/shares/ShareDetailPage/ShareDetailPage";

interface Props {
    isin: string;
}

export const ShareDetailPageContainer = ({ isin }: Props) => {
    const share = useShare(isin);

    if (!share) {
        return <Page>Aktie mit ISIN {isin} nicht gefunden.</Page>;
    }

    return <ShareDetailPage {...share} />;
};

export default ShareDetailPageContainer;
